import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBpwZLfX5tyCibScCJ0nhTXkq483eCER0Q",
  authDomain: "app-ninno.firebaseapp.com",
  databaseURL: "https://app-ninno-default-rtdb.firebaseio.com",
  projectId: "app-ninno",
  storageBucket: "app-ninno.firebasestorage.app",
  messagingSenderId: "885088241851",
  appId: "1:885088241851:web:6d71d27e037a542bc8819e",
  measurementId: "G-6JXDB6YNB0"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const storageFunction = getStorage(app);
export const db = getDatabase(app);

export const signInWithEmail = async (email: string, password: string) => {
  const userCredential = await signInWithEmailAndPassword(auth, email, password)
  return userCredential.user??false
}

export const signOutApp = async () => {
  await signOut(auth)
}
